import { render, staticRenderFns } from "./AnfrageAblehnenModal.vue?vue&type=template&id=56d45a16&"
import script from "./AnfrageAblehnenModal.vue?vue&type=script&lang=js&"
export * from "./AnfrageAblehnenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports